import Header from "../components/Header";
import Hero from "../components/Hero";
import RoomsSection from "../components/RoomsSection";
import FacilitiesSection from "../components/FacilitiesSection";
import AboutSection from "../components/AboutSection";
import ReviewsSection from "../components/ReviewsSection";
import PaymentInfoSection from "../components/PaymentInfoSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

export default function Landing() {
  return (
    <div className="App" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <RoomsSection />
        <FacilitiesSection />
        <AboutSection />
        <ReviewsSection />
        <PaymentInfoSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
